import { datadogRum } from '@datadog/browser-rum'
import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getMyAffiliates, getUser } from 'store/selectors'
import { User } from 'types'

export default function useAnalytics() {
  const { selectedAffiliate, isLoading: loadingAffiliates } =
    useSelector(getMyAffiliates)
  const user = useSelector(getUser) as User
  const location = useLocation()

  const handleLangChange = useCallback((mutationList) => {
    // EVENT: Lang Change
    if (mutationList.length) {
      const mutation = mutationList[0]

      if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
        const documentLang = document.documentElement.lang
        analytics.track('Browser Translated', { lang: documentLang })
      }
    }
  }, [])

  useEffect(() => {
    // EVENT: Page View
    if (!location.pathname.includes('redirect') && !loadingAffiliates) {
      const documentLang = document.documentElement.lang
      window.needsToTrackScrollDepth = true
      analytics.page({
        affiliateId: selectedAffiliate?.affiliateId,
        user_role:
          selectedAffiliate?.roles?.length > 0
            ? selectedAffiliate?.roles[0]
            : null,
        group_id: selectedAffiliate?.groupId,
        page_language: documentLang,
      })
    }
  }, [location, loadingAffiliates])

  useEffect(() => {
    // NOTE: use the observer to respond to DOM changes
    const observer = new MutationObserver(handleLangChange)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang'],
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    // EVENT: Data Dog User
    if (user) {
      datadogRum.setUser({ email: user.email, id: String(user.id) })
    }
  }, [user])
}
